/** Finance permission strings. */
export const FinancePermissions = {
  read: 'finance_read',
  manage: 'finance_manage',
  post: 'finance_post',
  workspaceAccess: ['finance_read', 'finance_manage', 'finance_post'] as const,
} as const
